"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KAYIT_ERISIM_YOK_METNI = exports.GOREV_NESNE_HEDEF_HARITASI = exports.ISLERIM_HEDEF_HARITASI = exports.ISLERIM_KAYNAKLARI = exports.BILDIRIM_OZET_TARIH_ANAHTARLARI = exports.BILDIRIM_HEDEF_HARITASI = exports.BILDIRIM_TIPLERI = exports.ISLERIM_YOLU = exports.KAYIT_YOLU = void 0;
exports.bildirimHedefYolu = bildirimHedefYolu;
/**
 * BİLDİRİM VE İŞ SATIRI HEDEFİ — TEK HARİTA (bulgu 103; Kapsam §14
 * K-103a…e · §22.2/11).
 *
 * ⚠️ **HER SATIR KAYNAĞINA GİDER; HEDEFİ OLMAYAN SATIR YAZILMAZ (K-103a).**
 * Zil · İşlerim · Genel bakış iş blokları yolunu BURADAN okur — ekran kendi
 * bağını kurmaz (K-103b). Tipler `Record` ile anahtarlıdır: yeni bir bildirim
 * tipi ya da kuyruk kaynağı hedefi yazılmadan DERLENMEZ; DB enum'uyla tam
 * eşitlik `@isg/db notifications-hedef.spec`te (K-103c).
 *
 * ⚠️ **HEDEF YETKİYİ GENİŞLETMEZ (K-103e).** Satır teslim anındaki şapka +
 * bahçeden doğar; sayfanın kapısı sunucuda koşar. Liste anında yeniden
 * yetki süzgeci YAZILMAZ — 40 tip için ikinci yetki yolu ikinci gerçek
 * kaynak olurdu.
 */
// ── Kayıt yolları — rota dizgesinin TEK yazıldığı yer ─────────────────────────
exports.KAYIT_YOLU = {
    aksiyon: (id) => `/aksiyonlar/${id}`,
    uygunsuzluk: (id) => `/uygunsuzluklar/${id}`,
    formKaydi: (id) => `/formlar/kayitlar/${id}`,
    sablon: (id) => `/formlar/sablonlar/${id}`,
    izin: (id) => `/izinler/${id}`,
    olay: (id) => `/olaylar/${id}`,
    ekipman: (id) => `/ekipman/${id}`,
    isyeri: (id) => `/organizasyon/isyeri/${id}`,
    gorev: (id) => `/ekipman/gorevler/${id}`,
    risk: (id) => `/risk/${id}`,
    yuklenici: (id) => `/yukleniciler/${id}`,
    kurul: (id) => `/isg-kurulu/${id}`,
    kurulToplantisi: (id) => `/isg-kurulu/toplanti/${id}`,
    kisi: (id) => `/calisanlar/${id}`,
    acilDurum: (workplaceId) => `/acil-durum/${workplaceId}`,
    kanaat: (id) => `/saglik/${id}`,
};
/** İşlerim sayfası — sahip kolunun geçici hedefi (sağlık kaydım bölümü). */
exports.ISLERIM_YOLU = '/islerim';
// ── Bildirim tipleri — `notification_tip` enum'unun TEK kopyası (DB ile tam eşitlik testi) ──
exports.BILDIRIM_TIPLERI = [
    'evrak_gecerlilik',
    'ekipman_kontrol',
    'bekleyen_hesap',
    'temsilci_daveti',
    'aktarma_sonucu',
    'aksiyon_atandi',
    'aksiyon_tamamlandi',
    'aksiyon_kapandi',
    'aksiyon_geri_acildi',
    'uygunsuzluk_bildirimi',
    'aksiyon_termin',
    'aksiyon_termin_yaklasiyor',
    'uygunsuzluk_hatirlatma',
    'ramak_kala_bildirimi',
    'ptw_onay_bekliyor',
    'ptw_onay_sonucu',
    'ptw_uygunsuzluk',
    'calisma_saati_duzeltme',
    'olay_bildirimi',
    'olay_durumu',
    'egitim_yetkinlik_vadesi',
    'saglik_kanaat_vadesi',
    'risk_yenileme_vadesi',
    'sgk_bildirim_vadesi',
    'eksik_temel_isg',
    'eksik_saglik_kanaati',
    'eksik_risk_degerlendirme',
    'hedefsiz_atama',
    'evrak_karari',
    'sozlesme_bitis_vadesi',
    'yukumluluk_gozden_gecirme_vadesi',
    'ptw_sure_dolumu',
    'ptw_devir_talebi',
    'kurul_toplanti_daveti',
    'kurul_karar_ilani',
    'kurul_kacinma_tebligi',
    'kurul_toplanti_vadesi',
    'kontrollu_belge_vadesi',
    'sablon_guncellendi',
    'sablon_gizlendi',
];
const dogrudan = (yol, liste, ozet) => ({
    sinif: 'dogrudan',
    yol: (g) => (g.kaynakRef ? yol(g.kaynakRef) : null),
    liste,
    ozet,
});
const turetilen = (ust, yol, liste, ozet) => ({
    sinif: 'turetilen',
    ust,
    yol: (g) => (g.ustRef ? yol(g.ustRef) : null),
    liste,
    ozet,
});
const liste = (yol, ozet) => ({
    sinif: 'liste',
    yol: () => null,
    liste: yol,
    ozet,
});
/** Portal kabuğunun kök sayfası (*Firmam*) — temsilci zil taşımaz. */
const PORTAL_KOK = '/';
const AKSIYON_OZETI = ['baslik', 'isyeriAd', 'termin'];
const UYGUNSUZLUK_OZETI = ['takipNo', 'uygunsuzluk', 'isyeriAd'];
const IZIN_OZETI = ['izinTuru', 'lokasyonAd', 'isyeriAd'];
const KURUL_OZETI = ['takipNo', 'isyeriAd', 'tarih'];
exports.BILDIRIM_HEDEF_HARITASI = {
    evrak_gecerlilik: turetilen('yuklenici_evrak', exports.KAYIT_YOLU.yuklenici, '/yukleniciler', [
        'firmaAd',
        'evrakTipiAd',
        'bitis',
    ]),
    ekipman_kontrol: dogrudan(exports.KAYIT_YOLU.ekipman, '/ekipman', [
        'ekipmanAd',
        'isyeriAd',
        'sonrakiKontrol',
    ]),
    // Kuyruk: Kullanıcılar ekranının *"Kişiye bağlanmayı bekleyen hesaplar"* süzgeci.
    bekleyen_hesap: liste('/kullanicilar', ['sayi']),
    temsilci_daveti: {
        sinif: 'zile_dusmez',
        yol: () => PORTAL_KOK,
        liste: PORTAL_KOK,
        ozet: ['firmaAd'],
    },
    // ⚠️ Liste konuyu (HANGİ kişilerin aktarmayla geldiği) göstermez — madde 264.
    aktarma_sonucu: liste('/calisanlar', ['isverenAd']),
    aksiyon_atandi: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    aksiyon_tamamlandi: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    aksiyon_kapandi: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    aksiyon_geri_acildi: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    uygunsuzluk_bildirimi: dogrudan(exports.KAYIT_YOLU.uygunsuzluk, '/uygunsuzluklar', UYGUNSUZLUK_OZETI),
    aksiyon_termin: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    aksiyon_termin_yaklasiyor: dogrudan(exports.KAYIT_YOLU.aksiyon, '/aksiyonlar', AKSIYON_OZETI),
    uygunsuzluk_hatirlatma: dogrudan(exports.KAYIT_YOLU.uygunsuzluk, '/uygunsuzluklar', UYGUNSUZLUK_OZETI),
    ramak_kala_bildirimi: dogrudan(exports.KAYIT_YOLU.formKaydi, '/formlar', [
        'sablonAd',
        'isyeriAd',
        'doldurmaTarihi',
    ]),
    ptw_onay_bekliyor: dogrudan(exports.KAYIT_YOLU.izin, '/izinler', IZIN_OZETI),
    ptw_onay_sonucu: dogrudan(exports.KAYIT_YOLU.izin, '/izinler', IZIN_OZETI),
    ptw_uygunsuzluk: dogrudan(exports.KAYIT_YOLU.izin, '/izinler', ['kalem']),
    // Çalışma saati ekranı işyeri × dönem ızgarasını gösterir.
    calisma_saati_duzeltme: liste('/olaylar/calisma-saatleri', ['isyeriAd', 'donem']),
    olay_bildirimi: dogrudan(exports.KAYIT_YOLU.olay, '/olaylar', [
        'turAd',
        'lokasyonAd',
        'isyeriAd',
        'takipNo',
    ]),
    olay_durumu: dogrudan(exports.KAYIT_YOLU.olay, '/olaylar', ['takipNo', 'durum']),
    egitim_yetkinlik_vadesi: turetilen('yetkinlik', exports.KAYIT_YOLU.kisi, '/egitimler', [
        'personAd',
        'yetkinlikAd',
        'bitis',
    ]),
    // Sahip (kişinin kendisi) kanaat detayını dar okuma listesi yüzünden
    // açamaz → İşlerim'deki *Sağlık kaydım* bölümü.
    saglik_kanaat_vadesi: {
        sinif: 'aliciya_gore',
        yol: (g) => (g.sahipMi ? exports.ISLERIM_YOLU : g.kaynakRef ? exports.KAYIT_YOLU.kanaat(g.kaynakRef) : null),
        liste: '/saglik',
        ozet: ['personAd', 'isyeriAd', 'bitis'],
    },
    risk_yenileme_vadesi: dogrudan(exports.KAYIT_YOLU.risk, '/risk', [
        'degerlendirmeAd',
        'isyeriAd',
        'bitis',
    ]),
    sgk_bildirim_vadesi: dogrudan(exports.KAYIT_YOLU.olay, '/olaylar', ['takipNo', 'isyeriAd', 'bitis']),
    // Eğitimler ekranının *"Kaydı yok (temel İSG eğitimi girilmemiş)"* süzgeci.
    eksik_temel_isg: liste('/egitimler', ['isyeriAd', 'sayi']),
    // Sağlık ekranının *"Kaydı yok"* süzgeci.
    eksik_saglik_kanaati: liste('/saglik', ['isyeriAd', 'sayi']),
    // Risk ekranının *"Risk değerlendirmesi olmayan işyerleri"* bandı.
    eksik_risk_degerlendirme: liste('/risk', ['isyeriAd']),
    // Görev kuralları ekranının *Hedefsiz* rozeti.
    hedefsiz_atama: liste('/ekipman/gorev-tanimlari', ['formAd', 'nesneAd']),
    evrak_karari: {
        sinif: 'zile_dusmez',
        yol: () => PORTAL_KOK,
        liste: PORTAL_KOK,
        ozet: ['evrakTipiAd'],
    },
    sozlesme_bitis_vadesi: dogrudan(exports.KAYIT_YOLU.yuklenici, '/yukleniciler', ['firmaAd', 'bitis']),
    // Takvim ekranının *Son gözden geçirme* satırı.
    yukumluluk_gozden_gecirme_vadesi: liste('/yasal-uygunluk', ['isyeriAd']),
    ptw_sure_dolumu: dogrudan(exports.KAYIT_YOLU.izin, '/izinler', IZIN_OZETI),
    ptw_devir_talebi: dogrudan(exports.KAYIT_YOLU.izin, '/izinler', IZIN_OZETI),
    kurul_toplanti_daveti: dogrudan(exports.KAYIT_YOLU.kurulToplantisi, '/isg-kurulu', KURUL_OZETI),
    kurul_karar_ilani: dogrudan(exports.KAYIT_YOLU.kurulToplantisi, '/isg-kurulu', KURUL_OZETI),
    kurul_kacinma_tebligi: dogrudan(exports.KAYIT_YOLU.kurulToplantisi, '/isg-kurulu', KURUL_OZETI),
    kurul_toplanti_vadesi: dogrudan(exports.KAYIT_YOLU.kurul, '/isg-kurulu', ['isyeriAd', 'bitis']),
    kontrollu_belge_vadesi: turetilen('kontrollu_belge', exports.KAYIT_YOLU.acilDurum, '/acil-durum', [
        'belgeTipi',
        'isyeriAd',
        'bitis',
    ]),
    sablon_guncellendi: dogrudan(exports.KAYIT_YOLU.sablon, '/formlar', ['sablonAd']),
    sablon_gizlendi: dogrudan(exports.KAYIT_YOLU.sablon, '/formlar', ['sablonAd']),
};
/** Tek okuyucu: tipin hedefi — kayıt yolu, yoksa liste. Boş dönmez (K-103a). */
function bildirimHedefYolu(tip, girdi) {
    const tanim = exports.BILDIRIM_HEDEF_HARITASI[tip];
    return tanim.yol(girdi) ?? tanim.liste;
}
/** Zil satırında TARİH olarak biçimlenecek içerik anahtarları (G11). */
exports.BILDIRIM_OZET_TARIH_ANAHTARLARI = [
    'termin',
    'bitis',
    'sonrakiKontrol',
    'doldurmaTarihi',
    'tarih',
];
// ── İş kuyrukları (İşlerim sayfası + Genel bakış bloğu) ────────────────────────
exports.ISLERIM_KAYNAKLARI = ['aksiyon', 'onay', 'gorev', 'onayim', 'katilimci'];
/**
 * Kuyruk kalemi → kayıt yolu. Girdi kalemin TAŞIDIĞI kayıt kimliğidir
 * (izin kuyruklarında izin id'si — kalemin kendi bileşik id'si değil).
 */
exports.ISLERIM_HEDEF_HARITASI = {
    aksiyon: exports.KAYIT_YOLU.aksiyon,
    onayim: exports.KAYIT_YOLU.aksiyon,
    onay: exports.KAYIT_YOLU.izin,
    katilimci: exports.KAYIT_YOLU.izin,
    gorev: exports.KAYIT_YOLU.gorev,
};
/**
 * *Süresi geçenler* satırı birden çok gecikmiş dönemi toplar — hedefi tek
 * görev değil, gecikmenin NESNESİDİR.
 */
exports.GOREV_NESNE_HEDEF_HARITASI = {
    ekipman: exports.KAYIT_YOLU.ekipman,
    isyeri: exports.KAYIT_YOLU.isyeri,
};
/**
 * K-103e — hedef sayfanın kapısı 403 döndüğünde gösterilen sebep. Kaydı
 * adlandırmaz: bahçe dışına bilgi sızmaz.
 */
exports.KAYIT_ERISIM_YOK_METNI = 'Bu kayda erişiminiz yok.';
//# sourceMappingURL=bildirim-hedef.js.map